import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    primary_color: '#0083cb'//'#00f9a9'
  },
  mutations: {
    set_primary_color (state, color) {
      state.primary_color = color
    }
  }
})




// WEBPACK FOOTER //
// ./src/store.js